import { Helpers } from '../../helpers';
import { IScenarioWell } from '../../interfaces/iscenario-well';
import { Area } from '../area';
import { ArtificialLiftType } from '../artificial-lift-type';
import { BatchProcessType } from '../batch-process-type';
import { Bullpen } from '../bullpen';
import { BullpenClassification } from '../bullpen-classification';
import { BullpenStatus } from '../bullpen-status';
import { CleanoutMethod } from '../cleanout-method';
import { CompletionDesign } from '../completion-design';
import { CurveBuild } from '../curve-build';
import { DrillGroup } from '../drill-group';
import { DrilloutMethod } from '../drillout-method';
import { FracGroup } from '../frac-group';
import { GelWeight } from '../gel-weight';
import { Item } from '../item';
import { Pad } from '../pad';
import { ProjectCompletionsParameter } from '../project-completions-parameter';
import { ProjectDrillingParameter } from '../project-drilling-parameter';
import { Rig } from '../rig';
import { Scenario } from '../scenario';
import { ScenarioWellShutIn } from '../scenario-well-shut-in';
import { TankBattery } from '../tank-battery';
import { Well } from '../well';

export class ScenarioWellBase {
  ScenarioWellId: number;
  ScenarioId: number;
  PadId: number | null;
  WellId: number;
  Ssn: string | null;
  DrillOrder: number | null;
  RigId: number | null;
  Wellname: string | null;
  TankBatteryId: number | null;
  PadOrder: number | null;
  LateralLength: number | null;
  UpdateTStamp: Date;
  UpdateUID: string | null;
  TrainAfe: string | null;
  ArtificialLiftTypeId: number | null;
  PreferredArtificialLiftTypeId: number | null;
  BullpenClassificationId: number | null;
  CleanoutMethodId: number | null;
  BatchProcess: boolean | null;
  WorkToAdvance: boolean | null;
  AddedToBullpenTimeStamp: Date | null;
  BullpenUpdateTimeStamp: Date | null;
  FracGroupId: number | null;
  DrilloutMethodId: number | null;
  JointVentureWell: boolean | null;
  StageCount: number | null;
  PlugBackTotalDepth: number | null;
  LandingPointTvd: number | null;
  GelWeightId: number | null;
  NetRevenueInterestPercent: number | null;
  OwnershipPercent: number | null;
  BullpenId: number | null;
  BullpenStatusId: number | null;
  IsManuallyIncludedWell: boolean;
  DrillDesignId: number | null;
  BatchProcessTypeId: number | null;
  SysActionUID: string | null;
  SysStartTime: Date;
  SysEndTime: Date;
  WalkDate: Date | null;
  StageLength: number | null;
  FluidSystemId: number | null;
  LinearGelPct: number | null;
  CrossLinkPct: number | null;
  SlickWaterPct: number | null;
  ClustersPerStage: number | null;
  StimEfficiency1: number | null;
  StimEfficiency2: number | null;
  StimEfficiency3: number | null;
  FluidQuantity: number | null;
  ProppantPoundsPerFt: number | null;
  ProppantType1ItemId: number | null;
  ProppantType1Percent: number | null;
  ProppantType2ItemId: number | null;
  ProppantType2Percent: number | null;
  ProppantType3ItemId: number | null;
  ProppantType3Percent: number | null;
  ProppantType4ItemId: number | null;
  ProppantType4Percent: number | null;
  ProppantType5ItemId: number | null;
  ProppantType5Percent: number | null;
  WellRiskOil: number | null;
  WellRiskGas: number | null;
  WellRiskWater: number | null;
  CompletionDesignId: number | null;
  DrillGroupId: number | null;
  IsIncluded: boolean;
  TankBatteryAreaId: number | null;
  WaterDisposalSystemAreaId: number | null;
  HasSpudderRig: boolean;
  SpudderRigId: number | null;
  FracOrder: number | null;
  FracPadOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  CompletedLateralLength: number | null;
  PumpRate: number | null;
  StageCountOverride: number | null;
  IsStageCountOverride: boolean | null;
  CurveBuildId: number | null;

  ProjectCompletionsParameters_ScenarioWell?: Array<ProjectCompletionsParameter> | null;
  ProjectDrillingParameters_ScenarioWell?: Array<ProjectDrillingParameter> | null;
  ScenarioWellShutIns_ScenarioWell?: Array<ScenarioWellShutIn> | null;
  ArtificialLiftType?: ArtificialLiftType;
  BatchProcessType?: BatchProcessType;
  BullpenClassification?: BullpenClassification;
  Bullpen?: Bullpen;
  BullpenStatus?: BullpenStatus;
  CleanoutMethod?: CleanoutMethod;
  CompletionDesign?: CompletionDesign;
  CurveBuild?: CurveBuild;
  DrillGroup?: DrillGroup;
  DrilloutMethod?: DrilloutMethod;
  FracGroup?: FracGroup;
  GelWeight?: GelWeight;
  Pad?: Pad;
  Scenario?: Scenario;
  TankBattery?: TankBattery;
  Well?: Well;
  PreferredArtificialLiftType?: ArtificialLiftType;
  ProppantType1Item?: Item;
  ProppantType2Item?: Item;
  ProppantType3Item?: Item;
  ProppantType4Item?: Item;
  ProppantType5Item?: Item;
  Rig?: Rig;
  Area?: Area;

  constructor(item?: IScenarioWell) {
    if (item) {

      this.ScenarioWellId = item.ScenarioWellId;
      this.ScenarioId = item.ScenarioId;
      this.PadId = item.PadId;
      this.WellId = item.WellId;
      this.Ssn = item.Ssn;
      this.DrillOrder = item.DrillOrder;
      this.RigId = item.RigId;
      this.Wellname = item.Wellname;
      this.TankBatteryId = item.TankBatteryId;
      this.PadOrder = item.PadOrder;
      this.LateralLength = item.LateralLength;
      this.UpdateTStamp = item.UpdateTStamp ? new Date(item.UpdateTStamp) : null;
      this.UpdateUID = item.UpdateUID;
      this.TrainAfe = item.TrainAfe;
      this.ArtificialLiftTypeId = item.ArtificialLiftTypeId;
      this.PreferredArtificialLiftTypeId = item.PreferredArtificialLiftTypeId;
      this.BullpenClassificationId = item.BullpenClassificationId;
      this.CleanoutMethodId = item.CleanoutMethodId;
      this.BatchProcess = item.BatchProcess;
      this.WorkToAdvance = item.WorkToAdvance;
      this.AddedToBullpenTimeStamp = item.AddedToBullpenTimeStamp ? new Date(item.AddedToBullpenTimeStamp) : null;
      this.BullpenUpdateTimeStamp = item.BullpenUpdateTimeStamp ? new Date(item.BullpenUpdateTimeStamp) : null;
      this.FracGroupId = item.FracGroupId;
      this.DrilloutMethodId = item.DrilloutMethodId;
      this.JointVentureWell = item.JointVentureWell;
      this.StageCount = item.StageCount;
      this.PlugBackTotalDepth = item.PlugBackTotalDepth;
      this.LandingPointTvd = item.LandingPointTvd;
      this.GelWeightId = item.GelWeightId;
      this.NetRevenueInterestPercent = item.NetRevenueInterestPercent;
      this.OwnershipPercent = item.OwnershipPercent;
      this.BullpenId = item.BullpenId;
      this.BullpenStatusId = item.BullpenStatusId;
      this.IsManuallyIncludedWell = item.IsManuallyIncludedWell;
      this.DrillDesignId = item.DrillDesignId;
      this.BatchProcessTypeId = item.BatchProcessTypeId;
      this.SysActionUID = item.SysActionUID;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;
      this.WalkDate = item.WalkDate ? new Date(item.WalkDate) : null;
      this.StageLength = item.StageLength;
      this.FluidSystemId = item.FluidSystemId;
      this.LinearGelPct = item.LinearGelPct;
      this.CrossLinkPct = item.CrossLinkPct;
      this.SlickWaterPct = item.SlickWaterPct;
      this.ClustersPerStage = item.ClustersPerStage;
      this.StimEfficiency1 = item.StimEfficiency1;
      this.StimEfficiency2 = item.StimEfficiency2;
      this.StimEfficiency3 = item.StimEfficiency3;
      this.FluidQuantity = item.FluidQuantity;
      this.ProppantPoundsPerFt = item.ProppantPoundsPerFt;
      this.ProppantType1ItemId = item.ProppantType1ItemId;
      this.ProppantType1Percent = item.ProppantType1Percent;
      this.ProppantType2ItemId = item.ProppantType2ItemId;
      this.ProppantType2Percent = item.ProppantType2Percent;
      this.ProppantType3ItemId = item.ProppantType3ItemId;
      this.ProppantType3Percent = item.ProppantType3Percent;
      this.ProppantType4ItemId = item.ProppantType4ItemId;
      this.ProppantType4Percent = item.ProppantType4Percent;
      this.ProppantType5ItemId = item.ProppantType5ItemId;
      this.ProppantType5Percent = item.ProppantType5Percent;
      this.WellRiskOil = item.WellRiskOil;
      this.WellRiskGas = item.WellRiskGas;
      this.WellRiskWater = item.WellRiskWater;
      this.CompletionDesignId = item.CompletionDesignId;
      this.DrillGroupId = item.DrillGroupId;
      this.IsIncluded = item.IsIncluded;
      this.TankBatteryAreaId = item.TankBatteryAreaId;
      this.WaterDisposalSystemAreaId = item.WaterDisposalSystemAreaId;
      this.HasSpudderRig = item.HasSpudderRig;
      this.SpudderRigId = item.SpudderRigId;
      this.FracOrder = item.FracOrder;
      this.FracPadOrder = item.FracPadOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.CompletedLateralLength = item.CompletedLateralLength;
      this.PumpRate = item.PumpRate;
      this.StageCountOverride = item.StageCountOverride;
      this.IsStageCountOverride = item.IsStageCountOverride;
      this.CurveBuildId = item.CurveBuildId;

      this.ProjectCompletionsParameters_ScenarioWell = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_ScenarioWell);
      this.ProjectDrillingParameters_ScenarioWell = Helpers.createClassArray(ProjectDrillingParameter, item.ProjectDrillingParameters_ScenarioWell);
      this.ScenarioWellShutIns_ScenarioWell = Helpers.createClassArray(ScenarioWellShutIn, item.ScenarioWellShutIns_ScenarioWell);
      this.ArtificialLiftType = new ArtificialLiftType(item.ArtificialLiftType);
      this.BatchProcessType = new BatchProcessType(item.BatchProcessType);
      this.BullpenClassification = new BullpenClassification(item.BullpenClassification);
      this.Bullpen = new Bullpen(item.Bullpen);
      this.BullpenStatus = new BullpenStatus(item.BullpenStatus);
      this.CleanoutMethod = new CleanoutMethod(item.CleanoutMethod);
      this.CompletionDesign = new CompletionDesign(item.CompletionDesign);
      this.CurveBuild = new CurveBuild(item.CurveBuild);
      this.DrillGroup = new DrillGroup(item.DrillGroup);
      this.DrilloutMethod = new DrilloutMethod(item.DrilloutMethod);
      this.FracGroup = new FracGroup(item.FracGroup);
      this.GelWeight = new GelWeight(item.GelWeight);
      this.Pad = new Pad(item.Pad);
      this.Scenario = new Scenario(item.Scenario);
      this.TankBattery = new TankBattery(item.TankBattery);
      this.Well = new Well(item.Well);
      this.PreferredArtificialLiftType = new ArtificialLiftType(item.PreferredArtificialLiftType);
      this.ProppantType1Item = new Item(item.ProppantType1Item);
      this.ProppantType2Item = new Item(item.ProppantType2Item);
      this.ProppantType3Item = new Item(item.ProppantType3Item);
      this.ProppantType4Item = new Item(item.ProppantType4Item);
      this.ProppantType5Item = new Item(item.ProppantType5Item);
      this.Rig = new Rig(item.Rig);
      this.Area = new Area(item.Area);
    }
  }
}